module.exports = __webpack_public_path__ + "img/hot_app.febb3a8d.gif";